import { useGoogleLogin } from '@react-oauth/google'
import { useNavigate } from 'react-router-dom'

import Button from 'src/ui/atoms/Button'

import useLoginApi from './useLoginApi'

const GoogleLoginComponent = ({
  handleLoginError,
  text,
}: {
  handleLoginError: Function
  text: string
}) => {
  const navigate = useNavigate()

  const { googleLogin } = useLoginApi()

  const login = useGoogleLogin({
    flow: 'auth-code',
    redirect_uri: window.location.href,
    onSuccess: async ({ code }) => {
      try {
        await googleLogin({ code })

        navigate('/dashboard')
      } catch (error) {
        //@ts-ignore
        if (error.response && error.response.status) {
          //@ts-ignore
          handleLoginError(error.response.status)
        }
      }
    },
  })

  return (
    <div className="relative grid w-full">
      {/* small hack here, can't use colored icons with the current logic */}
      <span className="icon-google absolute left-1/2 top-1/2 -translate-x-28 -translate-y-1/2 text-xl">
        <span className="path1" />
        <span className="path2" />
        <span className="path3" />
        <span className="path4" />
      </span>
      <Button name={text} type="secondary" onClick={() => login()} dataCy="login-google" />
    </div>
  )
}

export default GoogleLoginComponent
